import React,{ useState }  from 'react'
import '../CSS/SelectModeSession.css'
import H3 from "@material-tailwind/react/Heading3";
import H5 from "@material-tailwind/react/Heading5";
import Button from "@material-tailwind/react/Button";
import {useStateValue} from '../StateProvider';
import Calendar from './Calendar';
import NavOnlyIcons from './NavOnlyIcons';

const SelectModeSession = () => {

    
    const [dispatch] = useStateValue();
    const [visibleCal,setVisibleCal] = useState();


    const handleSelect1 = () => {
         dispatch({
            type : 'SET_MODE',
            mode : 'Chat'
        });
        setVisibleCal(true);
    }
    const handleSelect2 = () => {
         dispatch({
            type : 'SET_MODE',
            mode : 'Voice'
        });
        setVisibleCal(true);
    }
    const handleSelect3 = () => {
         dispatch({
            type : 'SET_MODE',
            mode : 'Video'
        });
        setVisibleCal(true);
    }
    return (
        <>        
        
        <div className="selectMode">
            <div className="navDiv">
                <NavOnlyIcons />
            </div>
            <div className="selectModeSubDiv">
                <div className="stepsDone">
                    <div className="stepOne" >       
                        <Button id='selectMode1'>1 Select Mode</Button>
                    </div>
                    
                    <div className="stepTwo">
                        <Button>2 Date & Time</Button>
                    </div>
                    <div className="stepThree">
                        <Button>3 Review data</Button>
                    </div>
                </div>
                 <H3 id='selectmodeHeading'>CHOOSE YOUR MODE OF CONTACT</H3>
                 <div className="modes" >
                    
                    <div className="chatMode" >
                        <H5 id="ModeHeading">
                            <i className="far fa-comments"></i>
                            <input type="Button" value='Chat'/>
                            
                        </H5>
                        <Button color="lightBlue" size="lg" ripple="light" onClick={handleSelect1}>Select</Button>
                        <h3>Rs. 799</h3>
                    </div>

                    <div className="VoiceMode" >
                        <H5 id="ModeHeading">
                            <i className="fas fa-phone-square-alt"></i>
                            <input type="Button" value='Voice' />
                           
                        </H5>
                         <Button color="lightBlue" size="lg" ripple="light" onClick={handleSelect2}>Select</Button>
                        <h3>Rs. 999</h3>
                    </div>

                    <div className="VideoMode">
                            <H5 id="ModeHeading">
                                <i className="fa fa-fas fa-video"></i>
                                <input type="Button" value='Video' />
                                
                            </H5>
                            <Button color="lightBlue" size="lg" ripple="light" onClick={handleSelect3}>Select</Button>
                        <h3>Rs. 1499</h3>
                    </div>

                 </div>
                { /*
                    getMode ? (
                        <Button id='selectDateAndTimeButton' color="lightBlue" size="lg" ripple="light" onClick={handleMode}>
                            Select Date and Time
                        </Button>
                    ) : (
                        <div></div>
                    ) 
                */}
               
            </div>
        </div>
        <div className={visibleCal ? "calDivModeShow" : "calDivMode"}>
            <Calendar />
        </div>
       
        
    </>
    )
}

export default SelectModeSession
